import React, { useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { USDollarCurrencyInputAdornment } from './USDollarCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { ExpenseClassEnum } from './ExpenseClass.enum';
import { USDollarCurrency } from '../../Configurations/ExpenseEntryConfig';

const PaymentAmount = (props) => {
    const { disabled, index, expense, isViewOnly, isInvoiceReviewLocked = false } = props;
    const { control, errors, setValue } = useFormContext();
    const paymentCurrencyFieldName = `expenseEntries[${index}].paymentCurrency`;

    const isPaymentExpense = expense.expenseClass === ExpenseClassEnum.Payment;

    useEffect(() => {
        // if the expense is a payment expense and the currency is not USD, set the currency to USD
        if (isPaymentExpense && expense.currency !== USDollarCurrency.value) {
            setValue(paymentCurrencyFieldName, USDollarCurrency.value);
        }
    }, [isPaymentExpense, expense.currency, paymentCurrencyFieldName]);

    return (
        <Grid2 item size={4}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].amount`}
                defaultValue={expense.amount}
                rules={{
                    required: 'Amount is required',
                    max: {
                        value: 99999.99,
                        message: "Amount can't exceed 99,999.99",
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required
                        placeholder="0.00"
                        id="payment-amount"
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label="Amount"
                        endAdornment={
                            isPaymentExpense ? (
                                <USDollarCurrencyInputAdornment />
                            ) : (
                                <AmountCurrencyInputAdornment
                                    disabled={disabled || isViewOnly || isInvoiceReviewLocked}
                                    index={index}
                                    currencyType={expense.currency}
                                    name={paymentCurrencyFieldName}
                                />
                            )
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.amount)}
                        disabled={isViewOnly || isInvoiceReviewLocked}
                        helperText={errors.expenseEntries?.[index]?.amount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default PaymentAmount;
